// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import ThemeColorPresets from './components/ThemeColorPresets';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import { SnackbarProvider } from 'notistack';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { QueryParamProvider } from 'use-query-params';

// ----------------------------------------------------------------------
const INITIAL_SETTINGS = {
  themeMode: 'light',
  themeDirection: 'rtl',
  themeColorPresets: 'purple',
  themeLayout: 'horizontal',
  themeStretch: true,
};

export default function App() {
  localStorage.setItem('settings', JSON.stringify(INITIAL_SETTINGS));
  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <ThemeProvider>
        <ThemeColorPresets>
          <RtlLayout>
            <MotionLazyContainer>
              <SnackbarProvider
                maxSnack={4}
                preventDuplicate
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <ProgressBarStyle />

                {/* <Settings /> */}
                <ScrollToTop />
                <Router />
              </SnackbarProvider>
            </MotionLazyContainer>
          </RtlLayout>
        </ThemeColorPresets>
      </ThemeProvider>
    </QueryParamProvider>
  );
}
